namespace $ {

	export type $shm_ba_pb_file_record = $shm_pocketbase_record
	export type $shm_ba_pb_file_item = $shm_pocketbase_file_item

	export class $shm_ba_pb extends $shm_pb {

		static user_agent_enabled( next?: boolean ) {
			const fallback = $mol_state_local.value< boolean >( 'hitalama_ba_agent_enabled' ) ?? false
			return this.user_setting( 'agent_enabled', next, fallback )
		}

		static user_agent_url( next?: string ) {
			return this.user_setting( 'agent_url', next, '' )
		}

		static user_agent_token( next?: string ) {
			return this.user_setting( 'agent_token', next, '' )
		}

		static user_wordstat_enabled() {
			const fallback = $mol_state_local.value< boolean >( 'hitalama_ba_wordstat_enabled' ) ?? false
			return this.user_setting( 'wordstat_enabled', undefined, fallback )
		}

		static user_mentions_enabled() {
			return this.user_setting( 'mentions_enabled', undefined, true )
		}

		static user_mention_stats_enabled() {
			return this.user_setting( 'mention_stats_enabled', undefined, false )
		}

		static user_wordstat_task_limit() {
			return Math.max( 0, Number( this.user_setting( 'wordstat_task_limit', undefined, 0 ) ) || 0 )
		}

		static user_wordstat_hourly_request_limit() {
			return Math.max( 0, Number( this.user_setting( 'wordstat_hourly_request_limit', undefined, 1000 ) ) || 0 )
		}

		static user_wordstat_query_limit() {
			return Math.max( 1, Number( this.user_setting( 'wordstat_query_limit', undefined, 200 ) ) || 200 )
		}

		static user_wordstat_subtask_limit() {
			return Math.max( 1, Number( this.user_setting( 'wordstat_subtask_limit', undefined, 1000 ) ) || 1000 )
		}

		static log_event( event: string ) {
			const user = this.user_id()
			if( !user ) return null

			const result = $mol_error_fence(
				()=> this.create_record( 'user_logs', {
					user,
					event,
					url: $mol_dom_context.location.href,
					user_agent: $mol_dom_context.navigator.userAgent,
				} ),
				()=> null,
				promise => promise,
			)

			if( !result || $mol_promise_like( result ) ) return null
			return result
		}

	}

}
